module.exports = __webpack_public_path__ + "static/media/Mix Management.5ffeeebb.svg";